window.setSliders = function () {


    var sliderEl = $('.main-slider');

    jQuery(sliderEl).dkJSUSlider({
        autoSlide: false,
        createNavigation: true,
        createPagination: false,
        keyboardActions: false,
        transition: function (oldSlide, newSlide, oldNb, nb, self) {
            var prevLeft = jQuery(sliderEl).width(),
                newLeft = 0 - prevLeft,
                newHeight = newSlide.find('.top-item-list').first().height();
            if (oldNb > nb) {
                var prevLeftTmp = prevLeft;
                prevLeft = newLeft;
                newLeft = prevLeftTmp;
            }
            self.wrapper.css('height', newHeight);
            newSlide.animate({
                left: prevLeft,
            }, 300,function () {
                self.canSlide = 1;

            }).css("left", prevLeft);

            oldSlide.animate({
                left: newLeft
            }, 300);
        }
    });
};

window.openCloseMenu = function () {
    let buttons = document.querySelectorAll(".btn-openclose");
    jQuery("body").toggleClass("menu-open");
    buttons.forEach(btn => {
        let img = btn.getElementsByTagName("img")[0];
        let iconClose = btn.querySelector("i")
        if (jQuery("body").hasClass("menu-open")) {
            img.style.display = "none";
            iconClose.style.display = "block";
        } else {
            img.style.display = "block";
            iconClose.style.display = "none";
        }
    })
    // Fermeture de la recherche si elle est ouverte
    jQuery(".search_container").removeClass("search--active");
    document.querySelector('body').style.overflowY = 'unset';
};

window.hideShowThings = function (el) {
    el
        .toggleClass("is-open")
        .next()
        .slideToggle("500");
};

window.truncateText = function (el) {
    var text = el.text().trim(),
        maxLength = 6;
    var trimmedString = text.substr(0, maxLength);

    var trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
    return trimmedString;
};

/**
 *
 * Move X elements into li for sliders
 * Usage : newElementsSlider(".need-newelements", 2);
 * Markup : div.need-newelements>div>.need-newelements-items
 *
 */

window.newElementsSlider = function (container, nbrItems) {
    var i = false,
        x = 0,
        $newlist = jQuery(container),
        itemsPerContainers = false,
        arrayItems = [],
        arrayItemsLength = false,
        classActiveBootstrap = "";

    if ($newlist.length > 0) {

        $newlist
            .addClass("need-newelements-resized")
            .find(".need-newelements-items").each(function (i, el) {
                arrayItems.push(el);
            });

        var itemsPerContainers = nbrItems,
            arrayItemsLength = arrayItems.length;

        $newlist.children("div").remove();

        for (i = 0; i < arrayItemsLength; i++) {
            if (i % itemsPerContainers == 0) {
                if (i === 0) {
                    classActiveBootstrap = "active";
                }
                $newlist.append("<div class='clearfix item " + classActiveBootstrap + "'></div>");
                classActiveBootstrap = "";
                x++;
            }
            jQuery(arrayItems[i]).appendTo($newlist.children("div:nth-child(" + x + ")"));
        }
        // createNavigation($newlist, arrayItemsLength);
    }
}

/*
 *
 *  Répartition des éléments des sliders
 *
 */

window.resizeSliders = function (width) {

    // Wide

    if (width >= 1400) {
        // newElementsSlider(".slider-nouveaute__inner", 8);
        newElementsSlider(".slider-topdumoment__inner", 5);
    }

    // Desktop

    if ((width >= 1024) && (width < 1400)) {
        // newElementsSlider(".slider-nouveaute__inner", 6);
        newElementsSlider(".slider-topdumoment__inner", 4);
    }

    // Tablette

    if ((width > 767) && (width < 1023)) {
        // newElementsSlider(".slider-nouveaute__inner", 5);
        newElementsSlider(".slider-topdumoment__inner", 4);
        newElementsSlider(".slider-avis__inner", 1);
    }

    // Mobile

    if (width <= 767) {
        // newElementsSlider(".slider-nouveaute__inner", 2);
        newElementsSlider(".slider-topdumoment__inner", 1);
        newElementsSlider(".slider-avis__inner", 1);
    }
};

window.windowWidth = function () {
    return document.documentElement.clientWidth || document.documentElement.clientWidth;
};

// Scroll Menu


window.scrollMenu = function (data) {

    var body = jQuery("body");
    body.toggleClass("onTop", data == 0 );
    if (data > 200) {
        body.addClass("sticky-header");
    } else {
        body.removeClass("sticky-header");
    }
};


// Resize playlist
window.setDimensions = function () {
    var windowsHeight = jQuery('.playlistoverview__medias img').height();
    jQuery('.playlistoverview__medias .dropdown-menu__alllinks').css('height', windowsHeight + 'px');
}

window.resizeBigSliderContainer = function () {

    var h = jQuery('.bs-slides .current .background-block').first().height();
    var w = jQuery('.bs-slides .current .background-block').first().width();
    if (h == 0) {
        return;
    }

    jQuery('.bs-slides .background-block').height(h);
    jQuery('.background-block').width(w);
    jQuery('.bs-slides').css('height', h);

}


window.addProductToCart = function (product, is_gift) {
    console.log('coucou', product, is_gift);
    var form, inputProduct;
    form = document.createElement('form');
    document.body.appendChild(form);
    inputProduct = document.createElement('input');
    inputProduct.name = 'product-item';
    inputProduct.value = product;
    form.appendChild(inputProduct);
    gift = document.createElement('input');
    gift.name = 'gift';
    gift.value = is_gift;
    console.log(is_gift);
    form.appendChild(gift);
    form.action = Routing.generate('user_cart_add_product_' + projectConfig.locale);
    form.method = 'POST';
    form.submit();
}

window.showFilmProducts = function (film_url, type, parameters) {
    var currentRoute, port, request, requestUrl;
    currentRoute = window.location;
    port = (currentRoute.port !== 80 && currentRoute.port !== '') ? (":" + currentRoute.port) : "";
    requestUrl = currentRoute.protocol + "//" + currentRoute.hostname + port
        + film_url + "/product/" + type;
    console.log(requestUrl);
    request = new Request();
    request.prepare('GET', requestUrl, true);
    request.sendRequest(parameters).then(function (response) {
        new Modal(response).showModal();
        var button, buttonsAddCard, _i, _len;
        buttonsAddCard = document.querySelectorAll("#form-option-film button");
        if (buttonsAddCard) {
            for (_i = 0, _len = buttonsAddCard.length; _i < _len; _i++) {
                button = buttonsAddCard[_i];
                button.addEventListener('click', function (e) {
                    var form, item, setItem;
                    item = this.getAttribute('data-item');
                    setItem = document.getElementById("product-item");
                    setItem.value = item;
                    form = document.getElementById("form-option-film");
                    form.submit();
                });
            }
        }
    });
}

window.showTrailer = function (trailerSrc, trailerType) {
    var modal = new Modal(jQuery('#template-modal-player-slideshow').text().replace('trailerSrc', trailerSrc).replace('trailerType', trailerType));
    modal.getModalElement().classList.add('modal-video-player');
    modal.showModal();
}

/**
 * Return true if email is OK
 *
 * @param email
 * @returns {boolean}
 */
window.IsEmail = function (email) {

    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

/**
 * Set newsletter field (home or footer) in error state
 * @param textField
 */
window.setNewsletterEmailTextInError = function (textField)
{
    textField.css("background-color","#ff9999");
    textField.css("background-image",jQuery("#email2").data("bgKo"));

    // Do not erase what user has wrote
    textField.unbind("focus");
    textField.focus(function() {
        textField.css("background-color","#fff");
    });
}

/**
 * Set newsletter field (home or footer) in success state
 * @param textField
 */
window.setNewsletterEmailTextInSuccess = function (textField)
{
    textField.css("background-color","#cccc99");
    textField.css("background-image",jQuery("#email2").data("bgOk"));
    textField.val(textField.data("textOk"));

    // Erase what user has wrote
    textField.focus(function() {
        textField.css("background-color","#fff");
        textField.val('');
    });
}


